/**
 * Генерация псевдоунимального числа.
 * Годиться для генерации id элементов, для которых нужен рандомный селектор
 */
export function getUniqueID() {
  return Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
}
